import * as React from 'react';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { getCheckboxState } from '@process-advisor/process-miner/slicers/variants/getCheckboxState';

export type UpdateVariantProps = {
    readOnly: boolean;
    checked: boolean;
    indeterminate: boolean;
};


type Props = {
    label: string;
    update: (
        props: UpdateVariantProps
    ) => void;
};

export const ShowCheckbox: React.FC<Props> = ({ label, update }) => {
    const [checked, setChecked] = React.useState(false);
    const [indeterminate, setIndeterminate] = React.useState(true);

    const handleOnChange = () => {
        const {
            checked: newChecked,
            indeterminate: newIndeterminate,
        } = getCheckboxState({ checked, indeterminate });
        setChecked(newChecked);
        setIndeterminate(newIndeterminate);
        update({
            readOnly: false,
            checked,
            indeterminate,
        });
    };

    return (
        <Checkbox
            label={label}
            checked={checked}
            indeterminate={indeterminate}
            handleOnChange={handleOnChange}
        />
    );
};
